import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendUseCaseSetting } from 'src/types/backend';

const QUERY = gql`
  query GenerationToolSettings {
    generationToolSetting {
      useCase
      badgeNew
      badgeImproved
    }
  }
`;

type Result = BackendUseCaseSetting[];

export const queryGenerationToolSettings = async () => {
  const result = await executeGqlQuery({ query: QUERY });
  return getSingleProp<Result>(result.data);
};
